import moment from "moment";
export default {
  methods: {
    getConditions(condition, colKey) { // filterModel to where params for firebase
      const { type, filter, filterTo, filterType, dateFrom, dateTo, values } = condition;
      switch (filterType) {
        case "text": {
          switch (type) {
            case "startsWith": // case sensitive
              return [[colKey, '>=', filter], [colKey, '<=', filter + '\uf8ff']];
            case "equals":
              return [[colKey, "==", filter]];
            case "notEqual":
              return [[colKey, "!=", filter]];
            default:
              return [[colKey, '>=', filter], [colKey, '<=', filter + '\uf8ff']];
          }
        }
        case "number": {
          switch (type) {
            case "equals":
              return [[colKey, "==", filter]];
            case "notEqual":
              return [[colKey, "!=", filter]];
            case "greaterThan":
              return [[colKey, ">", filter]];
            case "greaterThanOrEqual":
              return [[colKey, ">=", filter]];
            case "lessThan":
              return [[colKey, "<", filter]];
            case "lessThanOrEqual":
              return [[colKey, "<=", filter]];
            case "inRange":
              return [[colKey, ">=", filter], [colKey, "<=", filterTo]];
            case "blank":
              return [[colKey, "==", null]];
            case "notBlank":
              return [[colKey, ">", 0]];
            default:
              return [[colKey, "==", filter]];
          }
        }
        case "date": {
          const from = new Date(dateFrom);
          const fromDayStart = new Date(from.setHours(0, 0, 0, 0));
          const fromDayEnd = new Date (from.setHours(23, 59, 59, 999));

          switch (type) {
            case "equals":
              return [[colKey, ">=", fromDayStart], [colKey, "<=", fromDayEnd]];
            case "lessThan":
              return [[colKey, "<", fromDayStart]];
            case "greaterThan":
              return [[colKey, ">", fromDayEnd]];
            case "inRange":{
              const to = new Date(dateTo);
              const toDayEnd = new Date(to.setHours(23, 59, 59, 999));
              return [[colKey, ">=", fromDayStart], [colKey, "<=", toDayEnd]];
            }
            default:
              return [[colKey, ">", ""]];
          }
        }
        case "set": {
          return [[colKey, "in", values]];
        }
        case "week": { // custom filter
          const from = new Date(dateFrom);
          const to = new Date(dateTo);
          const fromDayStart = new Date(from.setHours(0, 0, 0, 0));
          const toDayEnd = new Date(to.setHours(23, 59, 59, 999));
          return [[colKey, ">=", fromDayStart], [colKey, "<=", toDayEnd]];
        }
      }
    },
    formatCondition(condition, key) {
      let formattedCondition = null;
      const { type, filter, filterTo, filterType, dateFrom, dateTo, values } = condition;

      switch (filterType) {
        case "text":
          switch (type) {
            case "contains":
              formattedCondition = `LOWER("${key}") LIKE LOWER('%${filter}%')`;
              break;
            case "notContains":
              formattedCondition = `LOWER("${key}") NOT LIKE LOWER('%${filter}%')`;
              break;
            case "equals":
              formattedCondition = `LOWER("${key}") = LOWER('${filter}')`;
              break;
            case "notEqual":
              formattedCondition = `LOWER("${key}") != LOWER('${filter}')`;
              break;
            case "startsWith":
              formattedCondition = `LOWER("${key}") LIKE LOWER('${filter}%')`;
              break;
            case "endsWith":
              formattedCondition = `LOWER("${key}") LIKE LOWER('%${filter}')`;
              break;
            case "blank":
              formattedCondition = `"${key}" IS NULL OR "${key}" = ''`;
              break;
            case "notBlank":
              formattedCondition = `"${key}" IS NOT NULL AND "${key}" != ''`;
              break;
            default:
              formattedCondition = ``;
              break;
          }
          break;
        case "number":
          switch (type) {
            case "equals":
              formattedCondition = `"${key}" = ${filter}`;
              break;
            case "notEqual":
              formattedCondition = `"${key}" != ${filter}`;
              break;
            case "greaterThan":
              formattedCondition = `"${key}" > ${filter}`;
              break;
            case "greaterThanOrEqual":
              formattedCondition = `"${key}" >= ${filter}`;
              break;
            case "lessThan":
              formattedCondition = `"${key}" < ${filter}`;
              break;
            case "lessThanOrEqual":
              formattedCondition = `"${key}" <= ${filter}`;
              break;
            case "inRange":
              formattedCondition = `"${key}" BETWEEN ${filter} AND ${filterTo}`;
              break;
            case "blank":
              formattedCondition = `"${key}" IS NULL`;
              break;
            case "notBlank":
              formattedCondition = `"${key}" IS NOT NULL`;
              break;
            default:
              formattedCondition = ``;
              break;
          }
          break;
        case "date":
          switch (type) {
            case "equals":
              formattedCondition = `"${key}" = '${dateFrom}'`;
              break;
            case "notEqual":
              formattedCondition = `"${key}" != '${dateFrom}'`;
              break;
            case "lessThan":
              formattedCondition = `"${key}" < '${dateFrom}'`;
              break;
            case "greaterThan":
              formattedCondition = `"${key}" > '${dateFrom}'`;
              break;
            case "inRange":
              formattedCondition = `"${key}" BETWEEN '${dateFrom}' AND '${dateTo}'`;
              break;
            case "blank":
              formattedCondition = `"${key}" IS NULL`;
              break;
            case "notBlank":
              formattedCondition = `"${key}" IS NOT NULL`;
              break;
            default:
              break;
          }
          break;
        case "set":
          if (values.length) {
            formattedCondition = `"${key}" IN ('${values.join("', '")}')`;
          }
          break;
        default:
          break;
      }
      return formattedCondition;
    },
    dateFilterComparator(filterLocalDateAtMidnight, cellValue) {
      const filter = moment(filterLocalDateAtMidnight).format("YYYY-MM-DD");
      if (cellValue < filter) {
        return -1;
      } else if (cellValue > filter) {
        return 1;
      }
      return 0;
    },
  },
};
